import React, { Component } from 'react';
import { connect } from 'react-redux';

import { receiveError } from '../../../../store/actions/notificationAction';

import addServicesRemote from '../../../../api/addServicesRemote';

import PerishableStorage from './PerishableStorage';

import Cart from '../../../../models/Cart';
import FeeTotal from '../../../../models/FeeTotal';
import CartItem from '../../../../models/CartItem';
import FeeParams from '../../../../models/FeeParams';
import CartService from '../../../../models/CartService';
import ApiResponse from '../../../../models/ApiResponse';
import ResponseError from '../../../../models/ResponseError';
import AddServicesUnits from '../../../../models/AddServicesUnits';

import { CART_ITEM_SCHEMA, findCartItemByCodeAndNumber, findCartItemService } from '../../../../utils/cartService';

import Moment from 'moment';

interface StorageProps {
  serviceDetails: AddServicesUnits;
  cart: Cart;
  serviceRawName: 'perishable_storage' | 'cage_vault';
  selectedAwbCode: string;
  selectedAwbNumber: string;
  selectedAwbVer: number;
  pickupDate: Date;
  receiveError: Function;
  handleChange: any;
  additionalInformation: string;
  disabled: boolean;
};

interface StorageState {
  cartItem: CartItem;
  calculations: FeeTotal;
  pickupDate: string;
};


/*
This container is used for both perishable storage service and cage vault. They are currently the same. 
*/
class PerishableStorageContainer extends Component<StorageProps, StorageState> {
  
  state = {
    cartItem: CART_ITEM_SCHEMA,
    calculations: {
      days: 0,
      storage_fee: 0,
      storage_units: 0,
      total: 0,
      total_min_cost_usd: 0
    },
    pickupDate:''
  }

  componentDidMount() {

    const cartItem: CartItem | undefined = findCartItemByCodeAndNumber(this.props.selectedAwbCode, this.props.selectedAwbNumber, this.props.cart);

    if (cartItem) {
      this.setState({ cartItem }, () => {
        this.loadData();
      });
    }
  }

  loadData = (): void => {
    
    let pickupDate: string = Moment(this.props.pickupDate).format('MMM DD, YY');
    let storageFeeService: CartService| undefined;
    if (this.state.cartItem.remainDue === 0) {

      storageFeeService = findCartItemService(this.state.cartItem, this.props.serviceRawName);

      if (storageFeeService) {

        const calculations: FeeTotal = storageFeeService.calculations;

        if(storageFeeService.params.pickupdate) {
          pickupDate = Moment(storageFeeService.params.pickupdate).format('MMM DD, YY');
        }

        this.setState({ calculations });
      } else {

        storageFeeService = findCartItemService(this.state.cartItem, 'storage_fee');
        
        if (storageFeeService && storageFeeService.params.pickupdate) {
          pickupDate = Moment(storageFeeService.params.pickupdate).format('MMM DD, YY');
          this.loadCalculations(pickupDate);
        }
      }
    } else {
      this.loadCalculations(pickupDate);
    }
    this.setState({ pickupDate });
  }

  loadCalculations = (pickupDate: string): void => {

    let optionalParams: FeeParams = {};
    optionalParams.pickupdate = Moment(pickupDate).format('YYYYMMDD');
    addServicesRemote.getFee(this.props.serviceRawName, this.props.selectedAwbCode, this.props.selectedAwbNumber, this.props.selectedAwbVer, optionalParams).then((res: ApiResponse<FeeTotal>) => {

      const result: FeeTotal | undefined = res.result;
      const error: ResponseError | undefined = res.error;

      if (result) {
        this.setState({ calculations: result });
      }

      if (error) {
        this.props.receiveError(error);
      }
    });
  }

  render () {
 
    const { serviceDetails } = this.props;
    const arrivalDate: string = Moment(this.state.cartItem.arrival_date).format('MMM DD, YY');
    const total: number = this.state.calculations.total || 0;

    return (
      <PerishableStorage
        serviceDetails={ serviceDetails }
        arrivalDate={ arrivalDate }
        pickupDate={ this.state.pickupDate }
        total={ total }
        calculations={ this.state.calculations }
        cartItemWeight={ this.state.cartItem.weight }
        handleChange={ this.props.handleChange }
        additionalInformation={ this.props.additionalInformation }
        disabled={ this.props.disabled }
      />
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    cart: state.cart,
    pickupDate: state.pickupDate
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PerishableStorageContainer);